import { Injectable, Inject } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Injectable({
   providedIn: 'root'
})
export class SEOService {
   constructor(
      private title: Title,
      private meta: Meta,
      @Inject(DOCUMENT) private doc: any
   ) {}

   updateTitle(title: string) {
      if (title) {
         this.title.setTitle(title);
      }
   }

   updateTags(tags: MetaDefinition[]) {
      if (!tags || !tags.length) return;
      tags.forEach(t => {
         // remove existing tag (by name or property) then add/update
         if (t.name) {
            this.meta.removeTag(`name='${t.name}'`);
            this.meta.addTag(t, false);
         } else if ((t as any).property) {
            this.meta.removeTag(`property='${(t as any).property}'`);
            this.meta.addTag(t, false);
         }
      });
   }

      addJSONLD(json: any, id: string = 'ld-json') {
         try {
            // remove existing JSON-LD with same id
            const existing = this.doc.head.querySelector(`script[type='application/ld+json'][data-id='${id}']`);
            if (existing) existing.remove();
            const script = this.doc.createElement('script');
            script.type = 'application/ld+json';
            script.setAttribute('data-id', id);
            script.text = JSON.stringify(json);
            this.doc.head.appendChild(script);
         } catch (e) {
            // ignore on server or when DOM not available
         }
      }

      removeTagBySelector(selector: string) {
         try {
            const el = this.doc.head.querySelector(selector);
            if (el) el.remove();
         } catch (e) { }
      }

   setCanonicalURL(url?: string) {
      const canURL = url ? url : this.doc.URL;
      let link: HTMLLinkElement = this.doc.querySelector("link[rel='canonical']");
      if (link) {
         link.setAttribute('href', canURL);
         return;
      }
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', canURL);
      this.doc.head.appendChild(link);
   }

   addLinkRel(rel: string, href: string) {
      try {
         if (!rel || !href) return;
         // remove existing
         const existing = this.doc.querySelectorAll(`link[rel='${rel}']`);
         existing.forEach((el: any) => el.remove());
         const link = this.doc.createElement('link');
         link.setAttribute('rel', rel);
         link.setAttribute('href', href);
         this.doc.head.appendChild(link);
      } catch (e) { }
   }

   removeLinkRel(rel: string) {
      try {
         if (!rel) return;
         const existing = this.doc.querySelectorAll(`link[rel='${rel}']`);
         existing.forEach((el: any) => el.remove());
      } catch (e) { }
   }

   setRobots(content: string) {
      if (!content) return;
      this.meta.removeTag(`name='robots'`);
      this.meta.addTag({ name: 'robots', content });
   }

   addHreflangLinks(hreflangData: Array<{ lang: string; href: string }>) {
      try {
         if (!hreflangData || !hreflangData.length) return;
         
         // Remove existing hreflang links
         const existing = this.doc.querySelectorAll(`link[rel='alternate'][hreflang]`);
         existing.forEach((el: any) => el.remove());
         
         // Add new hreflang links
         hreflangData.forEach((data) => {
            const link = this.doc.createElement('link');
            link.setAttribute('rel', 'alternate');
            link.setAttribute('hreflang', data.lang);
            link.setAttribute('href', data.href);
            this.doc.head.appendChild(link);
         });
      } catch (e) { }
   }

   addAlternateLink(hreflang: string, href: string) {
      try {
         if (!hreflang || !href) return;
         // Remove existing link with same hreflang
         const existing = this.doc.querySelector(`link[rel='alternate'][hreflang='${hreflang}']`);
         if (existing) existing.remove();
         
         const link = this.doc.createElement('link');
         link.setAttribute('rel', 'alternate');
         link.setAttribute('hreflang', hreflang);
         link.setAttribute('href', href);
         this.doc.head.appendChild(link);
      } catch (e) { }
   }
}